import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { UserNoPassword, SignupUserDto } from 'types';

export const createUser = ({
  data,
}: {
  data: SignupUserDto;
}): Promise<UserNoPassword> => {
  return axios.post('/api/auth/signup', data);
};

type UseCreateUserOptions = {
  config?: MutationConfig<typeof createUser>;
};

export const useCreateUser = ({ config }: UseCreateUserOptions = {}) => {
  return useMutation({
    onMutate: async (newUser) => {
      await queryClient.cancelQueries(['users']);

      const previousUsers = queryClient.getQueryData<UserNoPassword[]>([
        'users',
      ]);

      queryClient.setQueryData(['users'], [...(previousUsers || []), newUser]);

      return { previousUsers };
    },
    onError: (_, __, context: any) => {
      if (context?.previousUsers) {
        queryClient.setQueryData(['users'], context.previousUsers);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['users']);
    },
    ...config,
    mutationFn: createUser,
  });
};
